import { SEO } from "@/components/SEO";
import { HeroSection } from "@/components/home/HeroSection";
import { StatsSection } from "@/components/home/StatsSection";
import { TrustSignalsSection } from "@/components/home/TrustSignalsSection";
import { ServicesSection } from "@/components/home/ServicesSection";
import { ProcessSection } from "@/components/home/ProcessSection";
import { ReviewsSection } from "@/components/home/ReviewsSection";
import { EmergencySection } from "@/components/home/EmergencySection";
import { BoutiqueSection } from "@/components/home/BoutiqueSection";
import { TikTokSection } from "@/components/home/TikTokSection";
import { FacebookSection } from "@/components/home/FacebookSection";
import { BlogSection } from "@/components/home/BlogSection";
import { FAQSection } from "@/components/home/FAQSection";
import { PricingSection } from "@/components/home/PricingSection";
import { AreaServedSection } from "@/components/home/AreaServedSection";
import { PannesSection } from "@/components/home/PannesSection";
import { ShopServicesSection } from "@/components/home/ShopServicesSection";
import { QuoteSection } from "@/components/home/QuoteSection";

export default function HomePage() {
  return (
    <div className="min-h-screen" data-testid="home-page">
      <SEO
        title="Mediastore Niort - Spécialiste Apple n°1 à Niort & Deux-Sèvres | Réparation iPhone, Mac, iPad"
        description="🏆 N°1 réparateur Apple à Niort & Deux-Sèvres - 4,6/5 sur Google (212+ avis). Techniciens Apple certifiés : iPhone, iPad, MacBook, iMac. Aussi Samsung, Huawei, Xiaomi, PC. Diagnostic gratuit, garantie 6 mois. Intervention dans un rayon de 80 km autour de Niort 79000. ☎ 05 49 05 74 90"
        keywords="meilleur réparateur Apple Niort, spécialiste Apple Niort, Apple Niort, Apple Deux-Sèvres, réparation iPhone Niort, réparation Mac Niort, réparation MacBook Niort, réparation iPad Niort, techniciens certifiés Apple Niort, réparation téléphone Niort, réparation Samsung Niort, réparation Xiaomi Niort, réparation Huawei Niort, réparation tablette Niort, réparation ordinateur Niort, réparation PC Niort, dépannage informatique Niort, écran cassé iPhone Niort, batterie iPhone Niort, désoxydation téléphone Niort, récupération données Niort, Niort 79000, Chauray, Aiffres, Magné, Echiré, Saint-Maixent-l'École, Melle, Parthenay, Bressuire, Surgères, Marans, Saint-Jean-d'Angély, Fontenay-le-Comte, La Rochelle, Rochefort, Poitiers, Deux-Sèvres 79, Mediastore Niort"
        path="/"
        breadcrumbs={[{ name: "Accueil", path: "/" }]}
      />
      <HeroSection />
      <StatsSection />
      <TrustSignalsSection />
      <ServicesSection />
      <PannesSection />
      <ProcessSection />
      <ReviewsSection />
      <EmergencySection />
      <BoutiqueSection />
      <ShopServicesSection />
      <TikTokSection />
      <FacebookSection />
      <BlogSection />
      <FAQSection />
      <PricingSection />
      <AreaServedSection />
      <QuoteSection />
    </div>
  );
}
